// extracted by mini-css-extract-plugin
module.exports = {"page":"style_page__3ziEU","form":"style_form__V1LUm","button":"style_button__1ZjMn"};